export const EDIT_TOP_MATCHES = "EDIT_TOP_MATCHES";
export const EDIT_NEXT_MATCHES = "EDIT_NEXT_MATCHES";
export const EDIT_MATCHES_POINTS = "EDIT_MATCHES_POINTS";
export const EDIT_PREV_MATCHES = "EDIT_PREV_MATCHES";
export const LOADINGLIVE = "LOADINGLIVE";
export const CLEAR_PRED = 'CLEAR_PRED';
export const TOP_MATCHES_TEMP = 'TOP_MATCHES_TEMP';